export default __webpack_public_path__ + "static/media/oneUpLabs.393ca618.jpg";